<template>
	<div class="filter-detail-box">
		<div class="header">
			<b>{{ title }}</b>
			<button @click="isOpen = !isOpen" :class="isOpen ? 'minus' : 'plus'" v-if="clientHeight >= 78"></button>
		</div>
		<div class="content">
			<category-filter-list
				v-if="type == 'category'"
				:list="list"
				:filtered="filterList"
				:selected="selected"
				:isClassification="isClassification"
				@selectCategory="selectCategory"
				@checkCategory="checkCategory"
			/>
			<!--체크박스 필터 리스트-->
			<checkbox-list
				ref="checkbox-list"
				v-else-if="list.length > 0"
				:class="({ filtered: filterList.length > 0 }, { isScroll: clientHeight >= 78 })"
				:list="list"
				:filtered="filterList"
				:type="type"
				:isOpen="isOpen"
				@checkedList="checkedList"
			/>
		</div>
	</div>
</template>

<script>
import CategoryFilterList from '@/components/search/CategoryFilterList.vue'
import CheckboxList from '@/components/search/CheckboxList.vue'

export default {
	name: 'FilterDetailBox',
	props: {
		title: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		list: {
			type: Array,
			default: () => {},
		},
		//필터로 checked 된 리스트
		filtered: {
			type: Array,
			default: () => [],
		},
		//선택된 카테고리 / 분류
		selected: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		CheckboxList,
		CategoryFilterList,
	},
	computed: {
		filterList() {
			return this.filtered
		},
	},
	mounted() {
		this.measure()
		// 로딩 중 숨겨져 있다가(v-show) 보이는 경우에도 크기가 바뀌면 다시 잰다.
		if (typeof ResizeObserver !== 'undefined') {
			this.observer = new ResizeObserver(() => this.measure())
			this.observer.observe(this.$el)
		}
	},
	// 목록이 나중에 채워지거나(v-show로 숨겨져 있다가 보이는 경우 포함) 바뀌면 높이를 다시 잰다.
	updated() {
		this.measure()
	},
	beforeDestroy() {
		if (this.observer) this.observer.disconnect()
	},
	data() {
		return {
			isOpen: false,
			clientHeight: 0,
			isClassification: false,
		}
	},
	methods: {
		measure() {
			this.$nextTick(() => {
				const el = this.$refs['checkbox-list']?.$el?.firstChild
				if (el && el.clientHeight !== this.clientHeight) this.clientHeight = el.clientHeight
			})
		},
		//checked list emit
		checkedList(list) {
			this.$emit('checkedList', list, this.type)
		},
		selectCategory(item) {
			if (item) this.isClassification = true
			this.$emit('selectCategory', item)
		},
		checkCategory(list) {
			this.$emit('checkCategory', list)
		},
	},
}
</script>

<style lang="scss" scoped>
.filter-detail-box {
	width: 100%;
	display: flex;
	align-items: flex-start;
	border-bottom: 1px solid #f1f1f1;
	.header {
		width: 140px;
		align-self: stretch;
		background: #f7f7f4;
		font-size: 0.875rem;
		font-weight: 800;
		color: #161616;
		padding: 15px 20px 0;
		display: flex;
		align-items: flex-start;
		b {
			font-weight: 700;
		}
		button {
			margin-left: auto;
			width: 24px;
			height: 24px;
			background-repeat: no-repeat;
			background-size: 100%;
			background-position: center;
			border-radius: 4px;
			margin-top: -2px;
			// transition: all 0.3s;
			// &:hover {
			// 	background-color: $LIST_BACKGROUND;
			// }
			&.plus {
				background-image: url(~@/assets/svg/list-show.svg);
			}
			&.minus {
				background-image: url(~@/assets/svg/list-hide.svg);
			}
		}
	}
	.content {
		width: calc(100% - 140px);
		border-left: 1px solid #f1f1f1;
	}
}

/* 모바일: 라벨을 위에, 내용을 아래에 */
html.is-mobile .filter-detail-box {
	flex-direction: column;
	.header {
		width: 100%;
		align-self: auto;
		padding: 10px 14px;
		align-items: center;
	}
	.content {
		width: 100%;
		border-left: 0;
	}
}
</style>
